/**
 * @flow
 * @relayHash 38e7e34bd2409762b1fef6080fc6a2a7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateVueCommunicationMutationVariables = {|
  communicationId: string,
  heading: string,
  message: string,
  first: number,
|};
export type UpdateVueCommunicationMutationResponse = {|
  +updateVueCommunication: ?{|
    +vue: ?{|
      +vuecommunicationSet: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +heading: string,
            +message: ?string,
            +published: boolean,
            +publishedAt: ?any,
            +createdAt: any,
            +updatedAt: any,
          |}
        |}>
      |}
    |}
  |}
|};
export type UpdateVueCommunicationMutation = {|
  variables: UpdateVueCommunicationMutationVariables,
  response: UpdateVueCommunicationMutationResponse,
|};
*/


/*
mutation UpdateVueCommunicationMutation(
  $communicationId: ID!
  $heading: String!
  $message: String!
  $first: Int!
) {
  updateVueCommunication(communicationId: $communicationId, heading: $heading, message: $message) {
    vue {
      vuecommunicationSet(orderBy: "-createdAt", first: $first) {
        edges {
          node {
            id
            heading
            message
            published
            publishedAt
            createdAt
            updatedAt
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "communicationId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "heading",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "message",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "communicationId",
    "variableName": "communicationId"
  },
  {
    "kind": "Variable",
    "name": "heading",
    "variableName": "heading"
  },
  {
    "kind": "Variable",
    "name": "message",
    "variableName": "message"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "vuecommunicationSet",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": "-createdAt"
    }
  ],
  "concreteType": "VueCommunicationNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "VueCommunicationNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "VueCommunicationNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "heading",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "message",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "published",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "publishedAt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "createdAt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "updatedAt",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateVueCommunicationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateVueCommunication",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVueCommunication",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vue",
            "storageKey": null,
            "args": null,
            "concreteType": "VueNode",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateVueCommunicationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateVueCommunication",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVueCommunication",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vue",
            "storageKey": null,
            "args": null,
            "concreteType": "VueNode",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateVueCommunicationMutation",
    "id": null,
    "text": "mutation UpdateVueCommunicationMutation(\n  $communicationId: ID!\n  $heading: String!\n  $message: String!\n  $first: Int!\n) {\n  updateVueCommunication(communicationId: $communicationId, heading: $heading, message: $message) {\n    vue {\n      vuecommunicationSet(orderBy: \"-createdAt\", first: $first) {\n        edges {\n          node {\n            id\n            heading\n            message\n            published\n            publishedAt\n            createdAt\n            updatedAt\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9eddb3384c4ae8a6faf60cd1addd18e2';
module.exports = node;
